'use client';

import ProxyImage from '@shared/ProxyImage/ProxyImage';
import classNames from '@sindresorhus/class-names';
import {useMemo} from 'react';

import {ArticleFeaturingCardType} from '@strapi/types/Articles';

import styles from './FeaturingCard.module.scss';

type Props = {
  featuring: ArticleFeaturingCardType;
  index: number;
  onFeaturingCardInArticleClick?: (index: number) => void;
};

export default function FeaturingCard({
  featuring: {
    url,
    backgroundImage,
    title,
    textColorType,
    textUnderlayColor,
    category,
  },
  index,
  onFeaturingCardInArticleClick,
}: Props) {
  const style = useMemo<React.CSSProperties>(
    () => ({
      color:
        textColorType === 'light'
          ? 'var(--vk-white)'
          : 'var(--core-text-primary)',
      ...(textUnderlayColor && {'--underlay-color': textUnderlayColor}),
    }),
    [textColorType, textUnderlayColor],
  );
  return (
    <a
      href={url}
      className={styles.root}
      style={style}
      target="_blank"
      onClick={() => onFeaturingCardInArticleClick?.(index)}
    >
      <ProxyImage
        imageData={backgroundImage}
        className={styles.backgroundImage}
      />
      <div
        className={classNames(
          styles.textContainer,
          textUnderlayColor && styles.withUnderlay,
        )}
      >
        <div className={styles.category}>{category}</div>
        <div className={styles.title}>{title}</div>
      </div>
    </a>
  );
}
